<template>
  <div>
    <div class="w box">
      <img src="../static/indexImg.jpg" class="w" style="display:block;" />
      <div class="content">
        <div v-show="iosShow" @click="iosClick">
          <img src="../static/Apple.png" class="downLogo" />
          <div class="downText">IOS版本下载</div>
        </div>
        <div v-show="androidShow" @click="androidClick">
          <img src="../static/Android.png" class="downLogo" />
          <div class="downText">Android版本下载</div>
        </div>
      </div>
    </div>
    <img src="../static/AndroidBack.jpg" class="downBack" v-show="downShow"/>
  </div>
</template>

<script>

import axios from "axios";

export default {
    data(){
        return{
            downShow:false,
            androidShow:true,
            iosShow:true,
        }
    },
    methods: {
        iosClick(){
          // axios.post('https://da.addior.cn/app/req/v1/8002', base64Res({
          //   appId: '__UNI__A32DD81',
          //   osType: '1',
          // }))
          //   .then(function (res) {
          //     if(res.data.rspCode === '0000'){
          //       let result = JSON.parse(base64.decode(res.data.data))
          //       window.location.href=result.url
          //     }else{
          //       alert(res.data.rspMsg);
          //     }
          //   })
          //   .catch(function (error) {
          //     console.log(error);
          // });
        },
        androidClick(){
          const config = {
            // headers:{
            //   'Content-Type':'multipart/form-data',
            // }
          };
          axios.post('https://wifi.midianshangmeng.com/api/system/appVersionInfo/latestVersion', {
            appId: '__UNI__C268F0C',
            osType: '0',
          },config)
            .then(function (res) {
              if(res.data.code === 200){
                let result = res.data.data
                console.log(result)
                window.location.href=result.url
              }else{
                alert(res.data.msg);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
          // window.location.href="https://dashare.addior.cn/apk/v1.0.0_20211105_161035.apk"
        },
    }
};
</script>

<style scoped>
.w {
  width: 100%;
}
.box {
  position: relative;
}
.content {
  position: absolute;
  left: 0;
  top: 70%;
  color: #fff;
  display: flex;
  justify-content: center;
  width: 100%;
}
.downLogo {
  width: 30%;
  display: block;
  margin: 0 auto;
}
.downText {
  text-align: center;
  font-size: 14px;
  color: #89acfd;
  background: #fff;
  width: 80%;
  margin: 10%;
  border-radius: 50px;
  padding: 5px 0;
}
.downBack {
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
}
</style>
